import React from 'react';
import {Button, Card, Col, Form, FormControl, FormGroup, FormLabel, ListGroup, Modal, Row} from "react-bootstrap";
import {Glyph} from "../common/Glyph";
import {cols} from "./MarketingQueryView";

export default class MarketingQueryColumnsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCols: [...this.props.selectedCols]
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.show && this.props.show) {
            // becoming visible - reset state
            this.setState({
                selectedCols: [...this.props.selectedCols]
            });
        }
    }

    onOk = () => {
        this.props.onOk(this.state.selectedCols);
        this.props.onCancel();
    }

    moveRight = () => {
        let availList = document.getElementById("availableColsList");
        let keysToMove = Array.from(availList.options).filter(o => o.selected).map(o => o.value);
        let colArray = Object.entries(cols).map(c => c[1]);
        if (keysToMove && keysToMove.length > 0) {
            let newCols = this.state.selectedCols.concat(colArray.filter(c => keysToMove.includes(c.key)));
            this.setState({selectedCols: newCols});
        }
    }

    moveLeft = () => {
        let list = document.getElementById("selectedColsList");
        let keysToMove = Array.from(list.options).filter(o => o.selected).map(o => o.value);
        if (keysToMove && keysToMove.length > 0) {
            let newCols = this.state.selectedCols.filter(c => !keysToMove.includes(c.key));
            this.setState({selectedCols: newCols});
        }
    }

    moveUp = () => {
        let list = document.getElementById("selectedColsList");
        let options = Array.from(list.options);
        if (options.length === 0 || options[0].selected) return; //short circuit if empty list or first item is selected

        let cols = this.state.selectedCols;
        let changed = false;
        let newCols = new Array(options.length);

        for (let i=0; i < options.length; i++) {
            let o = options[i];
            if (i > 0 && o.selected) {
                // swap with the prev one
                newCols[i] = newCols[i-1];
                newCols[i-1] = cols[i];
                changed = true;
            } else {
                newCols[i] = cols[i];
            }
        }

        // only update state - UI element will update automatically
        if (changed) this.setState({selectedCols: newCols});
    }

    moveDown = () => {
        let list = document.getElementById("selectedColsList");
        let options = Array.from(list.options);
        if (options.length === 0 || options[options.length-1].selected) return; //short circuit if empty list or last item is selected

        let cols = this.state.selectedCols;
        let changed = false;
        let newCols = new Array(options.length);

        for (let i=options.length-1; i >= 0; i--) {
            let o = options[i];
            if (i < options.length-1 && o.selected) {
                // swap with the next one
                newCols[i] = newCols[i+1];
                newCols[i+1] = cols[i];
                changed = true;
            } else {
                newCols[i] = cols[i];
            }
        }

        // only update state - UI element will update automatically
        if (changed) this.setState({selectedCols: newCols});
    }

    render() {
        let selCols = this.state.selectedCols;
        let colArray = Object.entries(cols).map(c => c[1]);

        return <Modal size={"lg"} show={this.props.show} onHide={this.props.onCancel}>
            <Modal.Header>
                <Modal.Title>Select Display Columns</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={5}>
                        <FormLabel column={"sm"}>Available</FormLabel>
                        <FormControl id={"availableColsList"} as={"select"} htmlSize={10} custom multiple={true}>
                            {
                                colArray.filter(c => !selCols.includes(c)).map(c => <option key={c.key} value={c.key}>{c.label}</option>)
                            }
                        </FormControl>
                    </Col>
                    <Col md={1} className={"text-center"}>
                        <br/>
                        <br/>
                        <Button variant={"secondary"} onClick={this.moveRight}><Glyph name={"chevron-right"}/></Button>
                        <br/>
                        <br/>
                        <Button variant={"secondary"} onClick={this.moveLeft}><Glyph name={"chevron-left"}/></Button>
                    </Col>
                    <Col md={5}>
                        <FormLabel column={"sm"}>Selected</FormLabel>
                        <FormControl id={"selectedColsList"} as={"select"} htmlSize={10} custom multiple={true}>
                            {
                                selCols.map(c => <option key={c.key} value={c.key}>{c.label}</option>)
                            }
                        </FormControl>
                    </Col>
                    <Col md={1}>
                        <br/>
                        <br/>
                        <Button variant={"secondary"} onClick={this.moveUp}><Glyph name={"chevron-up"}/></Button>
                        <br/>
                        <br/>
                        <Button variant={"secondary"} onClick={this.moveDown}><Glyph name={"chevron-down"}/></Button>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onCancel}>
                    Cancel
                </Button>
                <Button variant="dark" onClick={this.onOk}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    }
}